import OrderFA from './fa/fa.json'

const OrderMessages = {
  fa: { ...OrderFA },
}

export default OrderMessages
